import { FC, useEffect, useRef } from "react";
import ChatGptImg from "../../img/chatgpt.png";
import MyImg from "../../img/me.png";
import { ResponseInterface } from "./response-interface";
import "./PromptResponseList.css";
import ReactMarkdown from "react-markdown";

interface PromptResponseListProps {
  responseList: ResponseInterface[];
}

const PromptResponseList: FC<PromptResponseListProps> = ({ responseList }) => {
  const responseListRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [responseList]);

  return (
    <div className="prompt-response-list" ref={responseListRef}>
      {responseList.map((responseData) => {
        const text = responseData.response?.trim() ?? "";

        return (
          <div
            className={
              "response-container " +
              (responseData.selfFlag ? "my-question" : "chatgpt-response")
            }
            key={responseData.id}
          >
            <img
              className="avatar-image"
              src={responseData.selfFlag ? MyImg : ChatGptImg}
              alt="avatar"
            />
            <div className="response-body">
              <span className="response-author">
                {responseData.selfFlag ? "Вие" : "НАП ИИ"}
              </span>
              <div
                className={
                  (responseData.error ? "error-response " : "") +
                  "prompt-content"
                }
                id={responseData.id}
              >
                {text ? (
                  <pre>
                    <ReactMarkdown children={text} />
                  </pre>
                ) : (
                  <span className="typing-indicator" aria-label="пише...">
                    <i />
                    <i />
                    <i />
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <div ref={scrollRef} />
    </div>
  );
};

export default PromptResponseList;
